import { Box, Grid, Typography } from "@mui/material";
import {
    EnhancedCheckboxRHF,
    LabelPosition,
    RHookFormDatePicker,
    RHookFormTextField,
    RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";
import { formatAmountCommaSeperator } from "../../../../common/Common";

import { RHookFormNumberField } from "./RHookFormNumberField";

interface IQuebecFormDataConstant {
    quebecFormData: any
    employeeTD1FromId: any
    selectedTD1Employee: any
    selectedTD1EmployeeDataByIddetails: any
    existingRecordData?: any;
    formMethods: any
    id: any,
    // quebecForm: any
}
export const QuebecFormDataConstant: FC<
    IQuebecFormDataConstant
> = ({ quebecFormData, existingRecordData, employeeTD1FromId, selectedTD1Employee, selectedTD1EmployeeDataByIddetails, formMethods, id }) => {
    const indexMap: any = {
        1: 1,
        2: 2,
        3: 3,
        4: 5,
        5: 6,
        6: 9,
        8: 11,
        9: 14,
        10: 20,
    };
    const newAddedRows = [
        {
            heading: "Add lines 1 through 6.",
            detail: null,
            value: null,
            indexForValue: 7,
        },
        {
            heading: "Add lines 7 and 9.",
            detail: null,
            value: null,
            indexForValue: 10,
        },
        {
            heading: null,
            detail: null,
            value: null,
            indexForValue: 15,
        },
        {
            heading: null,
            detail: null,
            value: null,
            indexForValue: 19,
        },
    ];
    const updatedQuebecFormData = [
        ...quebecFormData
            .filter((item: any) => indexMap[item.indexForValue])
            .map((item: any) => ({
                ...item,
                indexForValue: indexMap[item.indexForValue],
            })),
        ...newAddedRows,
    ].sort((a, b) => a.indexForValue - b.indexForValue);





    // const updatedQuebecFormData = quebecFormData.filter((x: any) => x.indexForValue !== 4)

    const [indexTwoCheckBox, setIndexTwoCheckBox] = useState(false);
    const [indexTwoCalculatedValue, setIndexTwoCalculatedValue] = useState<string | number>(0);
    const [indexSevenCalculatedValue, setIndexSevenCalculatedValue] = useState(updatedQuebecFormData[0].value);
    const [indexTenCalculatedValue, setIndexTenCalculatedValue] = useState(updatedQuebecFormData[0].value);
    const [indexNinteenCalculatedValue, setIndexNinteenCalculatedValue] = useState<string | number>(0);
    const [fieldclaimCodeAll, setFieldClaimCodeAll] = useState(false);
    const [indexTwentyCheckbox, setIndexTwentyCheckbox] = useState(false);

    const [tD1FieldId_1, tD1FieldId_3, tD1FieldId_5, tD1FieldId_6, tD1FieldId_9, tD1FieldId_14, tD1FieldId_15] = formMethods.watch(["tD1FieldId_1", "tD1FieldId_3", "tD1FieldId_5", "tD1FieldId_6", "tD1FieldId_9", "tD1FieldId_14", "tD1FieldId_15"]);

    const onIndexTwoFieldValueChangeHandler = (event: any) => {
        if (event.value !== null) {
            let indexTwoCalculatedValue = Number(tD1FieldId_1) - event.value
            setIndexTwoCalculatedValue(indexTwoCalculatedValue)
            let calculatedValueForIndexSeven = Number(tD1FieldId_1) + indexTwoCalculatedValue + Number(tD1FieldId_5) + Number(tD1FieldId_6) + Number(tD1FieldId_3)
            setIndexSevenCalculatedValue(calculatedValueForIndexSeven)
        }
    }

    useEffect(() => {
      
        if (selectedTD1Employee === 'create-new') {
            updatedQuebecFormData.forEach((item: any) => {
                if (item.indexForValue !== 1) {
                    formMethods.setValue(`tD1FieldId_${item.indexForValue}`, null);
                    formMethods.setValue(`tD1FieldId_20`, false);
                }
            });
            setFieldClaimCodeAll(false)
        }
    }, [selectedTD1Employee, employeeTD1FromId])

    const handleIndexTwoCheckBoxChangeHandler = (event: any) => {
        setIndexTwoCheckBox(event)
        if (!event) {
            formMethods.setValue('indexTwoField', null)
            setIndexTwoCalculatedValue('0.00')
            let calculatedValueForIndexSeven = Number(tD1FieldId_1) + 0 + Number(tD1FieldId_5) + Number(tD1FieldId_6) + Number(tD1FieldId_3)
            setIndexSevenCalculatedValue(calculatedValueForIndexSeven)
            setIndexTenCalculatedValue(calculatedValueForIndexSeven + Number(tD1FieldId_9))
        } else {
            // formMethods.setValue('indexTwoField', null)
            setIndexTwoCalculatedValue(updatedQuebecFormData[0].value)
            let calculatedValueForIndexSeven = Number(tD1FieldId_1) + updatedQuebecFormData[0].value + Number(tD1FieldId_5) + Number(tD1FieldId_6) + Number(tD1FieldId_3)
            setIndexSevenCalculatedValue(calculatedValueForIndexSeven)
            setIndexTenCalculatedValue(calculatedValueForIndexSeven + Number(tD1FieldId_9))
        }
    }

    const handleFieldSetClaimCodeAll = (check: boolean) => {
        setFieldClaimCodeAll(check)
        if (check) {
            updatedQuebecFormData.forEach((item: any) => {
                if (item.indexForValue !== 11 && item.indexForValue !== 14 && item.indexForValue !== 15) {
                    formMethods.setValue(`tD1FieldId_${item.indexForValue}`, null);
                    formMethods.setValue(`indexTwoField`, null);
                    formMethods.setValue(`tD1FieldId_20`, false);
                    formMethods.setValue(`checkbox-index-2`, false);
                }
            });
            setIndexTwoCalculatedValue(0)
            setIndexSevenCalculatedValue(0)
            setIndexTenCalculatedValue(0)
            setIndexTwoCheckBox(false)
        } else {
            formMethods.setValue(`tD1FieldId_1`, updatedQuebecFormData[0].value);
        }
    }

    const onIndexTwentyChckboxClickedHandler = (checked: any) => {
        setIndexTwentyCheckbox(checked)
    }
    const onFieldValueChangeHandler = (value: any, fieldIndex: any) => {
     
        if (fieldIndex === 3) {
            if (value) {
                let calculatedValue = Number(tD1FieldId_1) + Number(indexTwoCalculatedValue) + Number(tD1FieldId_5) + Number(tD1FieldId_6) + Number(value)
                setIndexSevenCalculatedValue(calculatedValue)
            } else {
                let calculatedValue = Number(tD1FieldId_1) + Number(indexTwoCalculatedValue) + Number(tD1FieldId_5) + Number(tD1FieldId_6) + 0
                setIndexSevenCalculatedValue(calculatedValue)
            }
        } else if (fieldIndex === 5) {
            if (value) {
                let calculatedValue = Number(tD1FieldId_1) + Number(indexTwoCalculatedValue) + Number(tD1FieldId_3) + Number(tD1FieldId_6) + Number(value)
                setIndexSevenCalculatedValue(calculatedValue)
            } else {
                let calculatedValue = Number(tD1FieldId_1) + Number(indexTwoCalculatedValue) + Number(tD1FieldId_3) + Number(tD1FieldId_6) + 0
                setIndexSevenCalculatedValue(calculatedValue)
            }
        } else if (fieldIndex === 6) {
            if (value) {
                let calculatedValue = Number(tD1FieldId_1) + Number(indexTwoCalculatedValue) + Number(tD1FieldId_5) + Number(tD1FieldId_3) + Number(value)
                setIndexSevenCalculatedValue(calculatedValue)
            } else {
                let calculatedValue = Number(tD1FieldId_1) + Number(indexTwoCalculatedValue) + Number(tD1FieldId_5) + Number(tD1FieldId_3) + 0
                setIndexSevenCalculatedValue(calculatedValue)
            }
        } else if (fieldIndex === 9) {
            if (value) {
                let calculatedValue = Number(indexSevenCalculatedValue) + Number(value)
                setIndexTenCalculatedValue(calculatedValue)
            } else {
                let calculatedValue = Number(indexSevenCalculatedValue) + 0
                setIndexTenCalculatedValue(calculatedValue)
            }
        } else if (fieldIndex === 14) {
            if (value) {
                let calculatedValue = Number(tD1FieldId_15) + Number(value)
                setIndexNinteenCalculatedValue(calculatedValue)
            } else {
                let calculatedValue = Number(tD1FieldId_15) + 0
                setIndexNinteenCalculatedValue(calculatedValue)
            }
        } else if (fieldIndex === 15 && value !== null) {
            if (value) {
                let calculatedValue = Number(tD1FieldId_14) + Number(value)
                setIndexNinteenCalculatedValue(calculatedValue)
            } else {
                let calculatedValue = Number(tD1FieldId_14) + 0
                setIndexNinteenCalculatedValue(calculatedValue)
            }
        }
    };
    // useEffect(() => {
    //     if (id) {
    //         const matchedItems = updatedupdatedQuebecFormDataWithoutTotalClaimAmount
    //             .filter((item: any) =>
    //                 item.indexForValue !== 1 &&
    //                 item.value !== null &&
    //                 item.templateValue !== null &&
    //                 item.value === item.templateValue
    //             )
    //             // .map((item: any) => ({
    //             //     value: item.templateValue,
    //             //     indexForValue: item.indexForValue
    //             // }));
    //             .map((item: any) => {
    //                 formMethods.setValue(`checkbox-${item.indexForValue}`, true); /// fix later to change this set claim all

    //                 return {
    //                     value: item.templateValue,
    //                     indexForValue: item.indexForValue
    //                 };
    //             });
    //         setCheckboxFieldValueSelected(matchedItems);
    //     }
    // }, [id]);
    return (
        <>

            <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} sx={{ marginBottom: "1.3rem" }}>
                <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}></Grid>
                <Grid size={{ xs: 9.66, sm: 9.66, md: 9.66, lg: 9.66, xl: 9.66 }}
                    sx={{
                        "& .MuiFormControlLabel-root": {
                            marginBottom: "0!important",
                            color: "rgba(0, 0, 0, 0.6)",
                        },
                        "& .MuiFormControlLabel-root .MuiTypography-root": {
                            fontSize: "0.875rem"
                        },
                        display: "flex", alignItems: "end"
                    }}
                >
                    <EnhancedCheckboxRHF
                        name={"setClaimCode"}
                        checked={fieldclaimCodeAll}
                        testId="setClaimCode"
                        checkboxLabel="Set CLAIM CODE to 0"
                        onSelectionChangeHandler={(check: boolean) => handleFieldSetClaimCodeAll(check)}
                    />
                </Grid>
                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }} sx={{
                    justifyContent: "end", display: "flex", "& .calenderWrapper ": {
                        marginBottom: "0!important",
                        minWidth: "178px!important"
                        // fontSize: ".875rem" 
                    }
                }}>
                    <RHookFormDatePicker
                        name="effectiveDate"
                        testId="TD1-date"
                        label="TD1 Date"
                        labelPosition={LabelPosition.Top}
                        format="M dd, yy"
                        labelColumns={4}
                        fieldColumns={8}
                    />
                </Grid>
            </Grid>


            {updatedQuebecFormData.map((item: any) => (
                <>
                    {item.indexForValue === 2 ?
                        (<Grid
                            container
                            key={item.indexForValue}
                            sx={{
                                marginBottom: "1.5rem",
                            }}
                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                        >
                            <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}>
                                <Box sx={{ display: "flex", alignItems: "start", marginRight: "1rem", marginTop: "0.2rem" }}>
                                    <Typography fontWeight="bold" fontSize=".875rem">
                                        {item.indexForValue}
                                    </Typography>
                                </Box>
                            </Grid>

                            <Grid size={{ xs: 11.7, sm: 11.7, md: 11.7, lg: 11.7, xl: 11.7 }}>
                                <Typography
                                    component="span"
                                    sx={{
                                        fontWeight: "bold", fontSize: ".875rem",
                                    }}
                                >
                                    {`${item.heading} `}

                                </Typography>
                                <Typography

                                    component="span"
                                    sx={{
                                        "& .MuiFormControlLabel-root": {
                                            width: "10px !important",
                                            height: "10px",
                                            marginBottom: "0!important",
                                        },
                                        "& .MuiFormHelperText-root": {
                                            display: "none",
                                        },

                                        marginRight: ".5rem",
                                        pointerEvents: fieldclaimCodeAll ? "none" : "auto",

                                    }}

                                >
                                    <EnhancedCheckboxRHF
                                        name={`checkbox-index-2`}
                                        checked={indexTwoCheckBox}
                                        disabled={fieldclaimCodeAll}
                                        testId={"checkbox-indexofValue"}
                                        onSelectionChangeHandler={handleIndexTwoCheckBoxChangeHandler}
                                    />
                                </Typography>
                                {/* <Typography
                                        component="span"
                                        sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", }}
                                    >
                                        {item.detail}
                                    </Typography> */}
                            </Grid>

                            <Grid
                                container
                                key={item.indexForValue}
                                sx={{
                                    marginBottom: "1.5rem",
                                }}
                                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            >

                                <Grid size={{ xs: 9.58, sm: 9.58, md: 9.58, lg: 9.58, xl: 9.58 }}>
                                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                        <Box
                                            sx={{
                                                textAlign: "end",
                                                // paddingRight: "14px",
                                                color: "#4b5563",
                                                fontFamily: '"Inter var", sans-serif',
                                                marginBottom: "24px"
                                            }}
                                        >

                                            {formatAmountCommaSeperator(updatedQuebecFormData[0].value)}
                                        </Box>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} container sx={{ marginBottom: "24px" }}>
                                        <Grid size={{ xs: 0.70, sm: 0.70, md: 0.70, lg: 0.70, xl: 0.70 }}></Grid>
                                        <Grid size={{ xs: 8.4, sm: 8.4, md: 8.4, lg: 8.4, xl: 8.4 }}>
                                            <Typography
                                                component="span"
                                                sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", }}
                                            >
                                                {item.detail}
                                            </Typography>
                                        </Grid>
                                        <Grid size={{ xs: 0.5, sm: 0.5, md: 0.5, lg: 0.5, xl: 0.5 }} sx={{ textAlign: "center", mt: "5px" }}>-</Grid>
                                        <Grid size={{ xs: 2.4, sm: 2.4, md: 2.4, lg: 2.4, xl: 2.4 }} sx={{
                                            justifyContent: "end", display: "flex",
                                            "& .numberFieldWrapper": {
                                                marginBottom: "0!important",
                                                width: "100%"
                                            },
                                        }}>
                                            <RHookFormNumberField
                                                id={`indexTwoField`}
                                                testId="indexTwoField"
                                                readOnly={
                                                    !indexTwoCheckBox
                                                }
                                                onChangeHandler={onIndexTwoFieldValueChangeHandler}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                                        <Box
                                            sx={{
                                                textAlign: "end",
                                                // paddingRight: "14px",
                                                color: "#4b5563",
                                                fontFamily: '"Inter var", sans-serif',
                                            }}
                                        >

                                            =&nbsp;{formatAmountCommaSeperator(indexTwoCalculatedValue)}
                                        </Box>

                                    </Grid>

                                </Grid>
                                <Grid size={{ xs: 0.4, sm: 0.4, md: 0.4, lg: 0.4, xl: 0.4 }} sx={{
                                    marginTop: "auto",
                                    color: "#4b5563",
                                    fontFamily: '"Inter var", sans-serif', textAlign: "center"
                                }}>+</Grid>
                                <Grid size={{ xs: 2.02, sm: 2.02, md: 2.02, lg: 2.02, xl: 2.02 }} sx={{ marginTop: "auto" }}>
                                    <Grid size={{ xs: 11.92, sm: 11.92, md: 11.92, lg: 11.92, xl: 11.92 }} sx={{
                                        justifyContent: "end", display: "flex",
                                        "& .numberFieldWrapper": {
                                            marginBottom: "0!important",
                                            width: "100%"
                                        },
                                    }}>
                                        <Box
                                            sx={{
                                                textAlign: "end",
                                                paddingRight: "14px",
                                                color: "#4b5563",
                                                fontFamily: '"Inter var", sans-serif',
                                            }}
                                        >

                                            {formatAmountCommaSeperator(indexTwoCalculatedValue)}
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>

                        </Grid>) :
                        item.indexForValue === 7 ?
                            (<Grid
                                container
                                key={item.indexForValue}
                                sx={{
                                    marginBottom: "1.5rem",
                                }}
                                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                            >
                                <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}>
                                    <Box sx={{ display: "flex", alignItems: "start", marginRight: "1rem", marginTop: "0.2rem" }}>
                                        <Typography fontWeight="bold" fontSize=".875rem">
                                            {item.indexForValue}
                                        </Typography>
                                    </Box>
                                </Grid>

                                <Grid size={{ xs: 9.32, sm: 9.32, md: 9.32, lg: 9.32, xl: 9.32 }}>
                                    <Typography
                                        component="span"
                                        sx={{
                                            fontSize: ".875rem",
                                        }}
                                    >
                                        {`${item.heading} `}

                                    </Typography>

                                </Grid>
                                <Grid size={{ xs: 0.28, sm: 0.28, md: 0.28, lg: 0.28, xl: 0.28 }} sx={{
                                    marginTop: "auto",
                                    color: "#4b5563",
                                    fontFamily: '"Inter var", sans-serif', textAlign: "center"
                                }}>=</Grid>
                                <Grid size={{ xs: 2.1, sm: 2.1, md: 2.1, lg: 2.1, xl: 2.1 }}>
                                    <Box
                                        sx={{
                                            textAlign: "end",
                                            paddingRight: "14px",
                                            color: "#4b5563",
                                            fontFamily: '"Inter var", sans-serif',
                                        }}
                                    >

                                        {formatAmountCommaSeperator(indexSevenCalculatedValue)}
                                    </Box>
                                </Grid>

                            </Grid>) :
                            item.indexForValue === 10 ?
                                (<Grid
                                    container
                                    key={item.indexForValue}
                                    sx={{
                                        marginBottom: "1.5rem",
                                    }}
                                    size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                                >
                                    <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}>
                                        <Box sx={{ display: "flex", alignItems: "start", marginRight: "1rem", marginTop: "0.2rem" }}>
                                            <Typography fontWeight="bold" fontSize=".875rem">
                                                {item.indexForValue}
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid size={{ xs: 9.32, sm: 9.32, md: 9.32, lg: 9.32, xl: 9.32 }}>
                                        <Typography
                                            component="span"
                                            sx={{
                                                fontSize: ".875rem",
                                            }}
                                        >
                                            {`${item.heading} `}

                                        </Typography>

                                    </Grid>
                                    <Grid size={{ xs: 0.28, sm: 0.28, md: 0.28, lg: 0.28, xl: 0.28 }} sx={{
                                        marginTop: "auto",
                                        color: "#4b5563",
                                        fontFamily: '"Inter var", sans-serif', textAlign: "center"
                                    }}>=</Grid>
                                    <Grid size={{ xs: 2.1, sm: 2.1, md: 2.1, lg: 2.1, xl: 2.1 }}>
                                        <Box
                                            sx={{
                                                textAlign: "end",
                                                paddingRight: "14px",
                                                color: "#4b5563",
                                                fontFamily: '"Inter var", sans-serif',
                                            }}
                                        >

                                            {formatAmountCommaSeperator(indexTenCalculatedValue)}
                                        </Box>
                                    </Grid>

                                </Grid>) :
                                item.indexForValue === 20 ?
                                    (<Grid
                                        container
                                        key={item.indexForValue}
                                        sx={{
                                            marginBottom: item.indexForValue === 14 ? 0 : "1.5rem",
                                        }}
                                        size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                                    >
                                        <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}>
                                            <Box sx={{ display: "flex", alignItems: "start", marginRight: "1rem", marginTop: "0.2rem" }}>
                                                <Typography fontWeight="bold" fontSize=".875rem">
                                                    {item.indexForValue}
                                                </Typography>
                                            </Box>
                                        </Grid>

                                        <Grid size={{ xs: 9.41, sm: 9.41, md: 9.41, lg: 9.41, xl: 9.41 }}>
                                            <Box sx={{ flex: 1, flexWrap: "" }}>
                                                <Typography
                                                    component={"div"}
                                                    sx={{
                                                        fontWeight: "bold", fontSize: ".875rem",
                                                    }}
                                                >
                                                    {`${item.heading}`}

                                                </Typography>
                                                <Typography
                                                    component="span"
                                                    sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", }}
                                                >
                                                    {item.detail}
                                                </Typography>

                                            </Box>

                                        </Grid>
                                        <Grid size={{ xs: 0.28, sm: 0.28, md: 0.28, lg: 0.28, xl: 0.28 }} sx={{
                                            marginTop: "5px",
                                            color: "#4b5563",
                                            fontFamily: '"Inter var", sans-serif', textAlign: "center",
                                            alignItems: "top", display: "flex"
                                        }}>
                                            {item.indexForValue === 3 || item.indexForValue === 5 || item.indexForValue === 6 || item.indexForValue === 9 || item.indexForValue === 15 ? "+" : ""}
                                        </Grid>
                                        <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }} sx={{
                                            justifyContent: "end", display: "flex",
                                            "& .MuiFormControlLabel-root": {
                                                margin: "0!important"
                                            },
                                            "& .MuiButtonBase-root": {
                                                paddingTop: "0!important"
                                            },
                                        }}>
                                            <EnhancedCheckboxRHF
                                                name={`tD1FieldId_${item.indexForValue}`}
                                                checked={indexTwentyCheckbox}
                                                testId={`tD1FieldId_${item.indexForValue}`}
                                                onSelectionChangeHandler={onIndexTwentyChckboxClickedHandler}
                                            />
                                        </Grid>
                                    </Grid>) :
                                    item.indexForValue === 15 ?
                                        (<Grid
                                            container
                                            key={item.indexForValue}
                                            sx={{
                                                // marginBottom: "1.5rem",
                                            }}
                                            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                                        >
                                            <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}>
                                                <Box sx={{ display: "flex", alignItems: "start", marginRight: "1rem", marginTop: "0.2rem" }}>
                                                    <Typography fontWeight="bold" fontSize=".875rem">
                                                        {item.indexForValue}
                                                    </Typography>
                                                </Box>
                                            </Grid>

                                            <Grid size={{ xs: 9.28, sm: 9.28, md: 9.28, lg: 9.28, xl: 9.28 }}>


                                            </Grid>
                                            <Grid size={{ xs: 0.4, sm: 0.4, md: 0.4, lg: 0.4, xl: 0.4 }} sx={{
                                                marginTop: "5px",
                                                color: "#4b5563",
                                                fontFamily: '"Inter var", sans-serif', textAlign: "center"
                                            }}>+</Grid>
                                            <Grid size={{ xs: 2.02, sm: 2.02, md: 2.02, lg: 2.02, xl: 2.02 }} sx={{
                                                justifyContent: "end", display: "flex",
                                                "& .numberFieldWrapper": {
                                                    marginBottom: "0!important",
                                                    width: "100%"
                                                },
                                            }}>
                                                <RHookFormNumberField
                                                    id={`tD1FieldId_15`}
                                                    testId="indexTwoField" onChangeHandler={(e: any) => onFieldValueChangeHandler(e.value, item.indexForValue)}
                                                />
                                            </Grid>

                                        </Grid>) :
                                        item.indexForValue === 19 ?
                                            (<Grid
                                                container
                                                key={item.indexForValue}
                                                sx={{
                                                    marginBottom: "1.5rem",
                                                }}
                                                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                                            >
                                                <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}>
                                                    <Box sx={{ display: "flex", alignItems: "start", marginRight: "1rem", marginTop: "0.2rem" }}>
                                                        <Typography fontWeight="bold" fontSize=".875rem">
                                                            {item.indexForValue}
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                                <Grid size={{ xs: 9.28, sm: 9.28, md: 9.28, lg: 9.28, xl: 9.28 }}>


                                                </Grid>
                                                <Grid size={{ xs: 0.4, sm: 0.4, md: 0.4, lg: 0.4, xl: 0.4 }} sx={{
                                                    marginTop: "auto",
                                                    color: "#4b5563",
                                                    fontFamily: '"Inter var", sans-serif', textAlign: "center"
                                                }}>=</Grid>
                                                <Grid size={{ xs: 2.02, sm: 2.02, md: 2.02, lg: 2.02, xl: 2.02 }}>
                                                    <Box
                                                        sx={{
                                                            textAlign: "end",
                                                            paddingRight: "14px",
                                                            color: "#4b5563",
                                                            fontFamily: '"Inter var", sans-serif',
                                                        }}
                                                    >

                                                        {formatAmountCommaSeperator(indexNinteenCalculatedValue)}
                                                    </Box>
                                                </Grid>

                                            </Grid>) :
                                            (<Grid
                                                container
                                                key={item.indexForValue}
                                                sx={{
                                                    marginBottom: item.indexForValue === 14 ? 0 : "1.5rem",
                                                }}
                                                size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
                                            >
                                                <Grid size={{ xs: .3, sm: .3, md: .3, lg: .3, xl: .3 }}>
                                                    <Box sx={{ display: "flex", alignItems: "start", marginRight: "1rem", marginTop: "0.2rem" }}>
                                                        <Typography fontWeight="bold" fontSize=".875rem">
                                                            {item.indexForValue}
                                                        </Typography>
                                                    </Box>
                                                </Grid>

                                                <Grid size={{ xs: 9.41, sm: 9.41, md: 9.41, lg: 9.41, xl: 9.41 }}>
                                                    <Box sx={{ flex: 1, flexWrap: "" }}>
                                                        <Typography
                                                            component={item.indexForValue === 14 ? "div" : item.indexForValue === 11 ? "div" : "span"}
                                                            sx={{
                                                                fontWeight: "bold", fontSize: ".875rem",
                                                            }}
                                                        >
                                                            {`${item.heading} ${item.indexForValue !== 14 && item.indexForValue !== 11 && item.detail ? "-" : ""} `}

                                                        </Typography>
                                                        <Typography
                                                            component="span"
                                                            sx={{ color: "rgba(0, 0, 0, 0.6)", fontSize: ".875rem", }}
                                                        >
                                                            {item.detail}
                                                        </Typography>

                                                    </Box>

                                                </Grid>
                                                <Grid size={{ xs: 0.28, sm: 0.28, md: 0.28, lg: 0.28, xl: 0.28 }} sx={{
                                                    marginTop: "5px",
                                                    color: "#4b5563",
                                                    fontFamily: '"Inter var", sans-serif', textAlign: "center",
                                                    alignItems: "top", display: "flex"
                                                }}>
                                                    {item.indexForValue === 3 || item.indexForValue === 5 || item.indexForValue === 6 || item.indexForValue === 9 || item.indexForValue === 15 ? "+" : ""}
                                                </Grid>
                                                <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2, xl: 2 }} sx={{
                                                    justifyContent: "end", display: "flex",
                                                    "& .numberFieldWrapper": {
                                                        marginBottom: "0!important",
                                                        width: "100%"
                                                    },
                                                }}>
                                                    {/* <RHookFormNumberField
                                                    id={`tD1FieldId_${item.indexForValue}`}
                                                    testId="item-indexofValue"
                                                    readOnly={
                                                        fieldclaimCodeAll || item.indexForValue === 1
                                                    }
                                                    // fieldValue={
                                                    //     fieldclaimCodeAll
                                                    //         ? null
                                                    //         : item.indexForValue === 1
                                                    //             ? item.value
                                                    //             : id
                                                    //                 ? item.value
                                                    //                 : null
                                                    // }
                                                    onChangeHandler={onFieldValueChangeHandler}
                                                /> */}
                                                    <RHookFormNumberField
                                                        id={`tD1FieldId_${item.indexForValue}`}
                                                        testId="item-indexofValue"
                                                        readOnly={item.indexForValue === 11 ? false : item.indexForValue === 14 ? false : fieldclaimCodeAll || item.indexForValue === 1}
                                                        defaultValue={item.value}
                                                        onChangeHandler={(e: any) => onFieldValueChangeHandler(e.value, item.indexForValue)}
                                                    />
                                                </Grid>
                                            </Grid>)}</>
            ))}

        </>
    );
};